export default "__VITE_ASSET__D1E8J4YC__"